import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function FloatingWhatsAppCTA() {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);

  /* 1. Détecter mobile vs desktop */
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  /* 2. Observer toute section formulaire sur la page courante */
  useEffect(() => {
    let observer: IntersectionObserver | null = null;

    const timer = setTimeout(() => {
      const sections = document.querySelectorAll('[id="inscription"]');

      if (sections.length === 0) {
        setIsFormVisible(false);
        return;
      }

      // Vérification initiale (utile si anchor direct #inscription)
      const anyInViewport = Array.from(sections).some((s) => {
        const r = s.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      });
      setIsFormVisible(anyInViewport);

      observer = new IntersectionObserver(
        (entries) => {
          const anyVisible = entries.some((e) => e.isIntersecting);
          setIsFormVisible(anyVisible);
        },
        { threshold: 0.1 },
      );

      sections.forEach((s) => observer?.observe(s));
    }, 100);

    return () => {
      clearTimeout(timer);
      observer?.disconnect();
    };
  }, [location.pathname]);

  const visible = isMobile && !isFormVisible;
  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 px-4 py-3 bg-white"
      style={{ boxShadow: '0 -4px 12px rgba(0,0,0,0.08)' }}
    >
      <a
        href="https://wa.me/596696846108"
        target="_blank"
        rel="noopener noreferrer"
        className="block text-center text-white font-semibold py-3.5 rounded-lg text-sm whitespace-nowrap transition-transform duration-150 active:scale-95"
        style={{ backgroundColor: '#25D366', fontFamily: 'DM Sans, sans-serif' }}
      >
        <i className="ri-whatsapp-line mr-2"></i>
        Rejoindre SOCAGEM
      </a>
    </div>
  );
}